'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _LoginModal = _interopRequireDefault(require("Modals/LoginModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FriseIcon = _interopRequireDefault(require("Icons/FriseIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class RessourcesPage extends _react.Component {
  state = {
    loading: false,
    blogs: [],
    blogs_count: 0,
    searched_title: '',
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchBlogs({});
  }
  fetchBlogs = _ref => {
    let {
      page,
      order,
      order_by,
      searched_title
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    console.log(searched_title);
    qwest.post('/blog/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      searched_title: searched_title || state.searched_title,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        blogs: response.blogs,
        blogs_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleSearchChange = _ref2 => {
    let {
      e,
      value,
      name
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_title: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchBlogs({
        searched_title: value
      });
    }, 800);
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchBlogs({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let role = app.state.session?.user?.roles[0];
    let ressources;
    if (role === "company" || role === "candidate") {
      ressources = (state.blogs || []).filter(ressource => ressource.visibility === true || ressource.category === role);
    } else {
      ressources = (state.blogs || []).filter(ressource => ressource.visibility === true);
    }
    ressources = (ressources || []).map(function (blog) {
      let visibility_className;
      blog?.visibility === false ? visibility_className = "c-blog-item--private" : visibility_className = "";
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item " + visibility_className,
        key: blog.id
      }, /*#__PURE__*/_react.default.createElement(_Image.default, {
        className: "c-blog-item__image",
        src: blog.images?.[0]?.url,
        alt: blog.title
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-blog-item__title"
      }, blog.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item__txt",
        dangerouslySetInnerHTML: {
          __html: blog.description
        }
      }), /*#__PURE__*/_react.default.createElement("a", {
        className: "c-blog-item__file",
        href: blog.documents[0]?.url,
        target: "_blank"
      }, "T\xE9l\xE9charger le document"), blog?.youtube_link && blog?.youtube_link !== "" ? /*#__PURE__*/_react.default.createElement("a", {
        href: blog?.youtube_link,
        className: "c-blog-item__file",
        target: "_blank"
      }, "Voir la vid\xE9o") : undefined);
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Ressources | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title u-text-center u-margin-bottom-0"
    }, "Ressources"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-bold u-margin-top-0"
    }, "D\xE9couvrez tous nos contenus \xE0 t\xE9l\xE9charger"), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "c-blog-search",
      name: "searched_title",
      label: "Rechercher",
      status: state.status_messages,
      value: state.searched_title
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-blog-list"
    }, ressources)));
    return output;
  }
}
exports.default = RessourcesPage;
